import { Camera, Scissors, Brush, Video, Shirt, Building2, Sparkles } from "lucide-react";

/** The 7 personas of the "Qui êtes-vous ?" section. Images live in /public/landing. */
export const PERSONAS = [
  {
    id: "mannequin", num: "01", icon: Sparkles, role: "talent", type: "mannequin",
    title: "Mannequin", subtitle: "Modèle · Performer",
    image: "/landing/mannequin.jpg",
    hook: "Votre book devient une page éditoriale. Vous êtes vu·e par celles et ceux qui castent vraiment.",
    benefits: [
      "Un portfolio éditorial haute définition, sans dépendre d'une agence",
      "Des castings, shootings et défilés ouverts chaque semaine",
      "Le concours du mois pour gagner en visibilité et en Premium",
    ],
    cta: "Créer mon profil Mannequin",
    quote: "« Je ne cherche plus les castings. Ce sont les créateurs qui me trouvent. »",
  },
  {
    id: "photographe", num: "02", icon: Camera, role: "creator", type: "photographer",
    title: "Photographe", subtitle: "Mode · Beauté · Édito",
    image: "/landing/photographe.jpg",
    hook: "Trouvez vos visages, composez vos équipes et publiez vos séries là où la mode regarde.",
    benefits: [
      "Recherche de talents par ville, type et univers visuel",
      "Collaborations publiées en quelques minutes, candidatures avec books complets",
      "Un profil créateur public pour exposer votre signature",
    ],
    cta: "Créer mon profil Photographe",
    quote: "« Un casting complet en 48 h, sans un seul message perdu. »",
  },
  {
    id: "styliste", num: "03", icon: Scissors, role: "creator", type: "stylist",
    title: "Styliste", subtitle: "Direction artistique",
    image: "/landing/styliste.jpg",
    hook: "Habillez les silhouettes qui comptent et trouvez des équipes aussi engagées que vous.",
    benefits: [
      "Showcase de vos looks, penderies et projets de défilé",
      "Connexion directe avec photographes, marques et mannequins",
      "Accès aux showrooms et événements presse de la communauté",
    ],
    cta: "Créer mon profil Styliste",
    quote: "« Mes looks ont enfin la scène qu'ils méritent. »",
  },
  {
    id: "maquilleur", num: "04", icon: Brush, role: "creator", type: "mua",
    title: "Maquilleur·se", subtitle: "Make-up · Hair",
    image: "/landing/maquilleur.jpg",
    hook: "Sublimez les visages de la mode de demain et faites de votre savoir-faire une signature.",
    benefits: [
      "Galerie beauté avant/après et gros plans éditoriaux",
      "Shootings beauté, backstage de défilés et castings régionaux",
      "Visibilité auprès des marques et des photographes qui recrutent",
    ],
    cta: "Créer mon profil Maquilleur·se",
    quote: "« Les marques me contactent directement depuis ma galerie. »",
  },
  {
    id: "videaste", num: "05", icon: Video, role: "creator", type: "videographer",
    title: "Vidéaste", subtitle: "Fashion film · Réalisation",
    image: "/landing/videaste.jpg",
    hook: "Capturez le mouvement, la lumière et l'énergie des défilés et des campagnes.",
    benefits: [
      "Fashion films et vidéos de couverture intégrés à votre profil",
      "Projets de défilés, lancements et campagnes à couvrir",
      "Un réseau de directeurs artistiques et de marques",
    ],
    cta: "Créer mon profil Vidéaste",
    quote: "« Chaque défilé est devenu un nouveau film pour mon portfolio. »",
  },
  {
    id: "createur_mode", num: "06", icon: Shirt, role: "creator", type: "fashion_designer",
    title: "Créateur de mode", subtitle: "Designer · Atelier",
    image: "/landing/createur_mode.jpg",
    hook: "Donnez vie à vos collections avec les équipes qui les porteront le mieux.",
    benefits: [
      "Recrutement complet pour capsules, lookbooks et défilés",
      "Mannequins, photographes et MUA réunis sur un même projet",
      "Événements, showrooms et concours pour révéler vos pièces",
    ],
    cta: "Créer mon profil Créateur",
    quote: "« Ma première collection a défilé grâce à une équipe trouvée ici. »",
  },
  {
    id: "marque", num: "07", icon: Building2, role: "creator", type: "brand",
    title: "Marque", subtitle: "Maison · Agence · Studio",
    image: "/landing/marque.jpg",
    hook: "Sourcez des visages authentiques, orchestrez vos castings et vos événements.",
    benefits: [
      "Moteur de recherche multicritère : ville, type, esthétique, niveau",
      "Publication de collaborations et gestion des candidatures en un lieu",
      "Événements privés, listes d'attente et billets QR pour vos invités",
    ],
    cta: "Rejoindre en tant que Marque",
    quote: "« Un vivier de talents qui ressemble enfin à notre image. »",
  },
];

export const registerPath = (p) => `/register?role=${p.role}&type=${p.type}`;
